import { render, staticRenderFns } from "./entrance.vue?vue&type=template&id=6d5e1731&scoped=true"
import script from "./entrance.vue?vue&type=script&lang=ts"
export * from "./entrance.vue?vue&type=script&lang=ts"
import style0 from "./entrance.vue?vue&type=style&index=0&id=6d5e1731&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5e1731",
  null
  
)

export default component.exports